import { render, staticRenderFns } from "./sponsor_user.vue?vue&type=template&id=a637bcc8&scoped=true&"
import script from "./sponsor_user.vue?vue&type=script&lang=js&"
export * from "./sponsor_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a637bcc8",
  null
  
)

export default component.exports